import React from "react";
import { useObjectUrl } from "../hooks/useObjectUrl";
import { Photo } from "../types/Photo";

interface PhotoPreviewModalProps {
  photo: Photo | null;
  onClose: () => void;
}

const PhotoPreviewModal: React.FC<PhotoPreviewModalProps> = ({
  photo,
  onClose,
}) => {
  const imageUrl = useObjectUrl(photo?.fullBlob);

  if (!photo) return null;

  return (
    <div className="modal modal-open">
      <div className="modal-box p-0 max-w-4xl bg-black relative overflow-hidden flex flex-col h-[80vh]">
        {/* Header */}
        <div className="absolute top-0 left-0 right-0 p-4 flex justify-between items-center bg-linear-to-b from-black/60 to-transparent z-10">
          <h3 className="text-white font-bold truncate pr-8">
            {photo.filename}
          </h3>
          <button
            className="btn btn-circle btn-sm btn-ghost text-white"
            onClick={onClose}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Image */}
        <div className="flex-1 flex items-center justify-center overflow-hidden">
          <img
            src={imageUrl}
            alt={photo.filename}
            className="max-w-full max-h-full object-contain"
          />
        </div>

        {/* Footer Info */}
        <div className="p-4 bg-black/60 text-white text-xs flex justify-between items-center">
          <div>
            {new Intl.DateTimeFormat("fr-FR", {
              dateStyle: "medium",
              timeStyle: "short",
            }).format(photo.createdAt)}
          </div>
          <div className="badge badge-outline badge-sm">
            {(photo.fullBlob.size / 1024 / 1024).toFixed(2)} MB
          </div>
        </div>
      </div>
      <div className="modal-backdrop" onClick={onClose}></div>
    </div>
  );
};

export default PhotoPreviewModal;
